import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "../lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(() => {
        const raw = localStorage.getItem("vf_user");
        return raw ? JSON.parse(raw) : null;
    });
    const [loading, setLoading] = useState(true);

    const persist = (token, u) => {
        localStorage.setItem("vf_token", token);
        localStorage.setItem("vf_user", JSON.stringify(u));
        setUser(u);
    };

    const setSession = persist;

    const refresh = (u) => {
        localStorage.setItem("vf_user", JSON.stringify(u));
        setUser(u);
    };

    const login = async (email, password) => {
        const { data } = await api.post("/auth/login", { email, password });
        persist(data.token, data.user);
        return data.user;
    };

    const register = async (email, password, name) => {
        const body = { email, password };
        if (name) body.name = name;
        const { data } = await api.post("/auth/register", body);
        persist(data.token, data.user);
        return data.user;
    };

    const logout = useCallback(() => {
        localStorage.removeItem("vf_token");
        localStorage.removeItem("vf_user");
        setUser(null);
    }, []);

    useEffect(() => {
        const token = localStorage.getItem("vf_token");
        if (!token) {
            setLoading(false);
            return;
        }
        api.get("/auth/me")
            .then(({ data }) => setUser(data))
            .catch(() => logout())
            .finally(() => setLoading(false));
    }, [logout]);

    return (
        <AuthContext.Provider value={{ user, loading, login, register, logout, refresh, setSession }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);
